<template>
  <div :class="className">
    <div class="sticky-select hide-tablet">
      <q-select
        ref="refCompanyFilter"
        label="Select company"
        v-model="companyFilter"
        outlined
        :disable="companies.length === 0 || loading"
        label-color="grey-7"
        color="grey-7"
        :options="companies"
        :option-label="(company) => company.name"
        :option-value="(company) => company.id"
        dense
      >
        <template v-slot:append>
          <q-icon
            size="15px"
            style="margin-top: 3px"
            v-if="!!companyFilter.id"
            class="cursor-pointer"
            name="fas fa-times"
            @click="companyFilter = ''"
            @click.stop="!companyFilter.id"
          />
        </template>
        <template v-slot:no-option>
          <q-item>
            <q-item-section class="text-italic text-grey">
              There is no options.
            </q-item-section>
          </q-item>
        </template>
      </q-select>
    </div>
    <div class="sticky-location hide-tablet">
      <q-select
        label="Select Location"
        v-model="multiFilter"
        outlined
        :display-value="shorter"
        multiple
        :disable="locations.length === 0 || loading || !companyFilter.id"
        label-color="grey-7"
        color="grey-7"
        :options="locations"
        dense
      >
        <template v-slot:append>
          <q-icon
            size="15px"
            style="margin-top: 3px"
            v-if="!!multiFilter.length > 0"
            class="cursor-pointer"
            name="fas fa-times"
            @click="multiFilter = []"
            @click.stop="!multiFilter.length === 0"
          />
        </template>
        <template v-slot:option="locations">
          <q-item
            :disable="loading"
            @click="locationFilterPusher(locations.opt)"
            dense
            clickable
            v-ripple
          >
            <q-item-section side top>
              <q-checkbox
                size="xs"
                v-model="multiFilter"
                :val="locations.opt"
              />
            </q-item-section>
            <q-item-section>{{ locations.opt.code }}</q-item-section>
          </q-item>
        </template>
        <template v-slot:no-option>
          <q-item>
            <q-item-section class="text-italic text-grey">
              There is no options.
            </q-item-section>
          </q-item>
        </template>
      </q-select>
    </div>
    <div class="sticky-select hide-tablet" style="margin-left:10px">
      <q-select
        label="Vehicle Condition Assumption"
        outlined
        label-color="grey-7"
        color="grey-7"
        :options="conditions"
        :option-label="(cond) => cond.name"
        v-model="conditionChooser"
        dense
      >
      </q-select>
    </div>
    <div class="sticky-select hide-tablet" style="margin-left:10px">
      <q-select
        label="Select Status"
        v-model="statusFilter"
        outlined
        :display-value="statusShorter"
        multiple
        label-color="grey-7"
        color="grey-7"
        :options="statuses()"
        dense
      >
        <template v-slot:append>
          <q-icon
            size="15px"
            style="margin-top: 3px"
            v-if="!!statusFilter.length > 0"
            class="cursor-pointer"
            name="fas fa-times"
            @click="statusFilter = []"
            @click.stop="!statusFilter.length === 0"
          />
        </template>
        <template v-slot:option="status">
          <q-item
            :disable="loading"
            @click="statusFilterPusher(status.opt)"
            dense
            clickable
            v-ripple
          >
            <q-item-section side top>
              <q-checkbox
                size="xs"
                v-model="statusFilter"
                :val="status.opt"
              />
            </q-item-section>
            <q-item-section>{{ status.opt.label }}</q-item-section>
          </q-item>
        </template>
        <template v-slot:no-option>
          <q-item>
            <q-item-section class="text-italic text-grey">
              There is no options.
            </q-item-section>
          </q-item>
        </template>
      </q-select>
    </div>
    <slot name="filter"></slot>
    <q-btn
      class="cursor-pointer q-ml-sm text-white bg-red-5"
      @click="clearFilter"
      label="Clear Filter"
    />
    <slot name="activator"></slot>
  </div>
</template>
<script>
import axios from "../axios/";
import {defaultStatuses, statuses} from "@/enums";
export default {
  props: {
    className: String,
  },
  async mounted() {
    if (this.$store.state.profit.companies.length === 0) {
      await this.getCompanies();
    }
    this.statusFilter = defaultStatuses;
  },
  methods: {
    statuses() {
      return statuses
    },
    async getCompanies() {
      const { data } = await axios.get("companies");
      this.companies = data.data;
    },
    locationFilterPusher(location) {
      if (this.multiFilter.some(item => item.id === location.id)) {
        const index = this.multiFilter
          .map(item => item.id)
          .indexOf(location.id);
        if (index !== -1) {
          this.$store.commit("profit/REMOVE_MULTI_FILTER", index);
        }
      } else {
        this.multiFilter = [...this.multiFilter, location];
      }
    },
    statusFilterPusher(status) {
      if (this.statusFilter.some(item => item.value === status.value)) {
        const index = this.statusFilter
          .map(item => item.value)
          .indexOf(status.value);
        if (index !== -1) {
          this.$store.commit("profit/REMOVE_STATUS_FILTER", index);
        }
      } else {
        this.statusFilter = [...this.statusFilter, status];
      }
    },
    clearFilter() {
      this.companyFilter = "";
      this.multiFilter = [];
      this.conditionChooser = { name: "Condition by Car", val: "default" };
      this.$store.commit("profit/SET_CONDITION_SETTER", this.conditionChooser);
      this.statusFilter = defaultStatuses;
      this.$emit("clear");
    },
  },
  computed: {
    conditions() {
      return this.$store.state.profit.conditions;
    },
    conditionChooser: {
      get() {
        return this.$store.state.profit.conditionChooser;
      },
      set(val) {
        this.$store.commit("profit/SET_CONDITION_SETTER", val);
      },
    },
    loading: {
      get() {
        return this.$store.state.profit.loading;
      },
      set(val) {
        this.$store.commit("profit/SET_LOADING", val);
      },
    },
    companyFilter: {
      get() {
        return this.$store.state.profit.companyFilter;
      },
      set(val) {
        this.$store.commit("profit/SET_COMPANY_FILTER", val);
      },
    },
    companies: {
      get() {
        return this.$store.state.profit.companies;
      },
      set(val) {
        this.$store.commit("profit/SET_COMPANIES", val);
      },
    },
    locations: {
      get() {
        return this.$store.state.profit.locations;
      },
      set(val) {
        this.$store.commit("profit/SET_LOCATIONS", val);
      },
    },
    shorter() {
      if (this.multiFilter.length > 0 && this.multiFilter.length < 2) {
        return this.multiFilter[0].code;
      } else if (this.multiFilter.length > 1) {
        return `${this.multiFilter[0].code} +${this.multiFilter.length - 1}`;
      }
    },
    multiFilter: {
      get() {
        return this.$store.state.profit.multiFilter;
      },
      set(val) {
        this.$store.commit("profit/SET_MULTI_FILTER", val);
      },
    },
    statusShorter() {
      if (this.statusFilter.length > 0 && this.statusFilter.length < 2) {
        return this.statusFilter[0].label;
      } else if (this.statusFilter.length > 2) {
        return `${this.statusFilter[0].label}, ${this.statusFilter[1].label} +${this.statusFilter.length - 2}`;
      }
    },
    statusFilter: {
      get() {
        return this.$store.state.profit.statusFilter;
      },
      set(val) {
        this.$store.commit("profit/SET_STATUS_FILTER", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.sticky-select,
.sticky-location {
    max-width: 200px;
}
@media only screen and (max-width: 767px) and (min-width: 300px) {
  .sticky-select {
    display: none;
  }
  .sticky-location {
    display: none;
  }
  .row-end {
    width: 100%;
    button {
      width: 100%;
    }
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .sticky-select {
    display: none;
  }
  .sticky-location {
    display: none;
  }
  .row-end {
    width: 100%;
  }
}
</style>
